import React, { useEffect, useState } from 'react';
import { useNavigate,useParams} from 'react-router-dom';

import { formatUSNumber, MakeAxiosRequest } from "../../utils/handler";
const RedirectComponent = () => {
    const navigate = useNavigate();
    

    
    useEffect(() => {
    const connectStripe = async () => {
      try {
         const queryParams = new URLSearchParams(window.location.search);

        // Extract the required parameters
        const scope = queryParams.get('scope');
        const code = queryParams.get('code');
        const state = queryParams.get('state');
           
        const res = await MakeAxiosRequest("get", "connect-stripe-web?code="+code+"&state="+state);
          if(res.status== 1){
              navigate('/stripe/success');
          }else{
              alert(res);
              navigate('/logout');
          }
        
          
        // handle success (e.g., navigate to another page or update state)
      } catch (error) {
        // handle error (e.g., show an error message)
        console.error(error);
      }
    };

    connectStripe();
  }, [ navigate]); // runs whenever params or navigate changes
    
};

export default RedirectComponent;

